@if(navigationItems && navigationItems.length > 0){
    <div dir="ltr" class="sx-nav-menu">
        <mat-list role="list" [ngClass]="{ 'sxl-flex-1': !isHandset }">
            @for(item of topLevelMenuItems; track item.id; let i = $index){

                @if(hasPermission(item) && (!item.children || item.children.length === 0)){
                    <ng-container [ngTemplateOutlet]="listItemLink"
                        [ngTemplateOutletContext]="{ item: item, first: i === 0 }">
                    </ng-container>
                }

                @if(isMenuExpanded && hasPermission(item) && (item.children && item.children.length > 0)){
                    <ng-container [ngTemplateOutlet]="navExpandedSubMenu"
                            [ngTemplateOutletContext]="{ item: item, first: i === 0 }">
                    </ng-container>
                }

                @if(!isMenuExpanded && hasPermission(item) && (item.children && item.children.length > 0)){
                    <ng-container [ngTemplateOutlet]="navCollapsedSubMenu"
                            [ngTemplateOutletContext]="{ item: item, first: i === 0 }">
                    </ng-container>
                }
            }
        </mat-list>
        
        @if(!isHandset){
            <div class="sx-nav-menu-expander">
                <button mat-button 
                    id="btnNavCollapseToggle"
                    [matTooltip]="expansionMenuButtonTooltip" 
                    [matTooltipShowDelay]="500"
                    class="sx-button sx-button--icon sx-button-semi-square" 
                    (click)="onExpandClick()">
                    @if(isMenuExpanded){
                        <svg>
                            <use xlink:href="#sx-double-arrow-left" href="#sx-double-arrow-left"></use>
                        </svg>   
                    }
                    @else {
                        <svg>
                            <use xlink:href="#sx-double-arrow-right" href="#sx-double-arrow-right"></use>
                        </svg>
                    }
                </button>
            </div>
        }
    </div> 
}

<ng-template #listItemLink let-item="item" let-first="first">
    @if(!item.externalRedirect){
        <button mat-list-item 
            class="sx-nav-menubutton"
            [matTooltip]="item.displayText"
            [matTooltipShowDelay]="500"
            [matTooltipDisabled]="item.disabled || isMenuExpanded"
            [disabled]="item.disabled"
            [activated]="item.active"
            [ngClass]="{ 'nav-disabled': item.disabled, 'nav-active': item.active, 'nav-expansion-item': first }"
            (click)="onMenuItemClick(item)">
            <div class="sx-nav-menuitem">
                @if(item?.iconName){
                    <span class="sx-nav-menuicon-container">
                        <svg>
                            <use [attr.xlink:href]="item.iconName" [attr.href]="item.iconName" />
                        </svg>
                    </span>
                }
                <span class="sx-nav-menu-text" data-cy="navigation-title">
                    {{ item.displayText }}
                </span>
            </div>
        </button>
    } 
    @else {
        <a mat-list-item class="sx-nav-menu-link"
            [matTooltip]="item.displayText"
            [matTooltipShowDelay]="500"
            [matTooltipDisabled]="item.disabled || isMenuExpanded"
            [ngClass]="{ 'nav-disabled': item.disabled }"
            [href]="item.linkUrl" 
            target="_blank"> 
            <div class="sx-nav-menuitem">
                @if(item?.iconName && item.parentId === TOP_NODE_ID){
                    <span class="sx-nav-menuicon-container"> 
                        <svg>
                            <use [attr.xlink:href]="item.iconName" [attr.href]="item.iconName" />
                        </svg>
                    </span>
                }
                <span class="sx-nav-menu-text" [ngClass]="{ 'sx-nav-menu-icon-after': item.parentId !== TOP_NODE_ID }" data-cy="navigation-title">
                    {{ item.displayText }}
                </span>
                @if(item?.iconName && item.parentId !== TOP_NODE_ID){
                    <span class="sx-nav-menuicon-external-submenu-container"> 
                        <svg>
                            <use [attr.xlink:href]="item.iconName" [attr.href]="item.iconName" />
                        </svg>
                    </span>
                }
            </div>
        </a>
    }
</ng-template>

<ng-template #navExpandedSubMenu let-item="item">
    <mat-expansion-panel class="sx-nav-menu-item" 
        [disabled]="item.disabled"
        [ngClass]="{ 'nav-disabled': item.disabled }"
        [expanded]="item.active || (!!selectedItem && item.id === selectedItem.parentId)">

        <mat-expansion-panel-header>
            <div class="sx-nav-menuitem"
                matTooltip="{{ item.displayText }}"
                [matTooltipShowDelay]="500"
                [matTooltipDisabled]="item.disabled || isMenuExpanded">
                <span class="sx-nav-menuicon-container">
                    @if(item?.iconName){
                        <svg>
                            <use [attr.xlink:href]="item.iconName" [attr.href]="item.iconName" />
                        </svg>
                    }
                </span>
                <span class="sx-nav-menu-text"  data-cy="navigation-title">{{ item.displayText }}</span>
            </div>
        </mat-expansion-panel-header>
        <mat-list role="list">
            @for(subItem of getChildren(item); track subItem.id){
                @if(hasPermission(subItem)){
                    <ng-container [ngTemplateOutlet]="listItemLink" 
                        [ngTemplateOutletContext]="{ item: subItem, first: false }">
                    </ng-container>
                }
            }
        </mat-list>
    </mat-expansion-panel>
</ng-template>

<ng-template #navCollapsedSubMenu let-item="item">
    <button mat-list-item 
        [matMenuTriggerFor]="subMenu"
        class="sx-nav-menubutton"
        [disabled]="item.disabled"
        [ngClass]="{ 'nav-disabled': item.disabled, 'nav-active': item.active } "
        [matTooltip]="item.displayText"
        [matTooltipDisabled]="item.disabled || isMenuExpanded">
        <div class="sx-nav-menuitem">
            <span class="sx-nav-menuicon-container">
                @if(item?.iconName){
                    <svg>
                        <use [attr.xlink:href]="item.iconName" [attr.href]="item.iconName" />
                    </svg>
                }
            </span>
            <span class="sx-nav-menu-text sxh-hidden"  data-cy="navigation-title">{{item.displayText}}</span>
            @if(!item.disabled){
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" aria-hidden="true" focusable="false"><path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path></svg>
                </span>
            }
        </div>
    </button>
    <mat-menu #subMenu="matMenu" [overlapTrigger]="false" yPosition="below">
        @for(subItem of getChildren(item); track subItem.id){
            @if(hasPermission(subItem)){
                @if(!subItem.externalRedirect){
                    <button mat-menu-item 
                        (click)="onMenuItemClick(subItem)" 
                        [disabled]="subItem.disabled"
                        [ngClass]="{ 'nav-disabled': subItem.disabled, 'nav-active': subItem.active }">
                        <div class="sx-nav-menuitem">
                            @if(subItem?.iconName){
                                <span class="sx-nav-menuicon-container">
                                    <svg>
                                        <use [attr.xlink:href]="subItem.iconName" [attr.href]="subItem.iconName" />
                                    </svg>
                                </span>
                            }
                            <span class="sx-nav-menu-text" data-cy="navigation-title">
                                {{ subItem.displayText }}
                            </span>
                        </div>
                    </button>
                }
                @else {
                    <a mat-list-item class="sx-nav-menu-link"
                        [ngClass]="{ 'nav-disabled': subItem.disabled }"
                        [href]="subItem.linkUrl" 
                        target="_blank"> 
                        <div class="sx-nav-menuitem">
                            <span class="sx-nav-menu-text" [ngClass]="{ 'sx-nav-menu-icon-after': subItem.parentId !== TOP_NODE_ID }" data-cy="navigation-title">
                                {{ subItem.displayText }}
                            </span>
                            @if(subItem?.iconName && subItem.parentId !== TOP_NODE_ID){
                                <span class="sx-nav-menuicon-external-submenu-container"> 
                                    <svg>
                                        <use [attr.xlink:href]="subItem.iconName" [attr.href]="subItem.iconName" />
                                    </svg>
                                </span>
                            }
                        </div>
                    </a>
                }
            }
        }
    </mat-menu>
</ng-template>

